export class Type {
  public name = '';
  public description = '- Välj -';
}
